// Test IDs for the Agenda (internal scheduling) feature.

export const AGENDA_SOURCE_LEGEND = 'agenda-source-legend';

export const AGENDA = {
  page: 'agenda-page',
  viewDayButton: 'agenda-view-day-button',
  viewWeekButton: 'agenda-view-week-button',
  viewMonthButton: 'agenda-view-month-button',
  todayButton: 'agenda-today-button',
  prevButton: 'agenda-prev-button',
  nextButton: 'agenda-next-button',
  currentRangeLabel: 'agenda-current-range-label',
  professionalFilterSelect: 'agenda-professional-filter-select',
  sourceFilterSelect: 'agenda-source-filter-select',
  statusFilterSelect: 'agenda-status-filter-select',
  newAppointmentButton: 'agenda-new-appointment-button',
  newBlockButton: 'agenda-new-block-button',
  calendarContainer: 'agenda-calendar-container',
  // Fix AR (2026-10-27): aviso de reservas nuevas desde la pagina
  onlineBanner: 'agenda-online-banner',
  onlineMarkSeenButton: 'agenda-online-mark-seen-button',
  onlineItemPrefix: 'agenda-online-item-', // + appointmentId
  eventPrefix: 'agenda-event-', // agenda-event-<appointmentId>
  blockEventPrefix: 'agenda-block-event-', // agenda-block-event-<blockId>

  // Detail modal for an existing appointment
  detailModal: 'agenda-detail-modal',
  detailPatientName: 'agenda-detail-patient-name',
  detailService: 'agenda-detail-service',
  detailProfessional: 'agenda-detail-professional',
  detailTime: 'agenda-detail-time',
  detailNotes: 'agenda-detail-notes',
  detailOrigin: 'agenda-detail-origin',
  detailStatusSelect: 'agenda-detail-status-select',
  detailEditButton: 'agenda-detail-edit-button',
  detailCancelAppointmentButton: 'agenda-detail-cancel-appointment-button',
  detailCloseButton: 'agenda-detail-close-button',

  // Create/Edit appointment modal
  modal: 'agenda-appointment-modal',
  modalPatientSearchInput: 'agenda-modal-patient-search-input',
  modalPatientOptionPrefix: 'agenda-modal-patient-option-', // + patientId
  modalPatientCreateToggle: 'agenda-modal-patient-create-toggle',
  modalPatientNewNameInput: 'agenda-modal-patient-new-name-input',
  modalPatientNewPhoneInput: 'agenda-modal-patient-new-phone-input',
  modalPatientNewEmailInput: 'agenda-modal-patient-new-email-input',
  modalPatientCreateButton: 'agenda-modal-patient-create-button',
  modalSelectedPatientBadge: 'agenda-modal-selected-patient-badge',
  modalProfessionalSelect: 'agenda-modal-professional-select',
  modalServiceSelect: 'agenda-modal-service-select',
  modalDateInput: 'agenda-modal-date-input',
  modalTimeInput: 'agenda-modal-time-input',
  modalDurationLabel: 'agenda-modal-duration-label',
  modalNotesInput: 'agenda-modal-notes-input',
  modalSaveButton: 'agenda-modal-save-button',
  modalCancelButton: 'agenda-modal-cancel-button',
  modalErrorMessage: 'agenda-modal-error-message',

  // Block modal
  blockModal: 'agenda-block-modal',
  blockProfessionalSelect: 'agenda-block-professional-select',
  blockStartInput: 'agenda-block-start-input',
  blockEndInput: 'agenda-block-end-input',
  blockReasonInput: 'agenda-block-reason-input',
  blockSaveButton: 'agenda-block-save-button',
  blockCancelButton: 'agenda-block-cancel-button',
  blockDeleteButtonPrefix: 'agenda-block-delete-button-',
};
